export const booleanFilters = [
  'include_candidate_resume_in_search'
];
